import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./DeleteProduct.css";
import Layout from "../../components/layout";

const DeleteProduct = () => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [products, setProducts] = useState([]);

  // Fetch categories from the API
  const fetchCategories = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/categories`
      );
      const data = await response.json();
      setCategories(data);
    } catch (error) {
      toast.error("Fehler beim Abrufen der Kategorien.");
    }
  };

  // Fetch products based on selected category
  const fetchProductsByCategory = async (category) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/getraenke/${category}`
      );
      const data = await response.json();
      setProducts(data);
    } catch (error) {
      toast.error("Fehler beim Abrufen der Produkte.");
    }
  };

  // Delete product
  const deleteProduct = async (id) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/getraenke/${id}`,
        {
          method: "DELETE",
        }
      );

      if (!response.ok) throw new Error("Fehler beim Löschen des Produkts");

      toast.success("Produkt erfolgreich gelöscht.");
      fetchProductsByCategory(selectedCategory); // Refresh product list after deletion
    } catch (error) {
      toast.error("Fehler beim Löschen des Produkts.");
    }
  };

  const handleCategoryChange = (e) => {
    const category = e.target.value;
    setSelectedCategory(category);
    if (category) {
      fetchProductsByCategory(category);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <Layout>
      <div className="Bottom Top">
        <div className="Bottom12">
        <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={true}
            newestOnTop={true}
            closeOnClick
            pauseOnHover
            limit={1} // Limits to one toast visible at a time
            style={{ width: "250px", fontSize: "14px" }} />
          <div className="delete-product-container">
            <h2>Produkte löschen</h2>

            {/* Dropdown for selecting category */}
            <div className="category-selector">
              <label htmlFor="category-select">Kategorie auswählen:</label>
              <select
                id="category-select"
                value={selectedCategory}
                onChange={handleCategoryChange}
              >
                <option value="">Kategorie auswählen</option>
                {categories.map((category, index) => (
                  <option key={index} value={category}>
                    {category.charAt(0).toUpperCase() + category.slice(1)}
                  </option>
                ))}
              </select>
            </div>

            {/* List of products if a category is selected */}
            {selectedCategory && (
              <ul className="product-list">
                {products.length > 0 ? (
                  products.map((product) => (
                    <li key={product.id} className="product-item">
                      <div className="product-details">
                        <h3>{product.title}</h3>
                        <p>Menge: {product.menge || "Keine Angabe"}</p>
                        <p>Preis: {product.preis} €</p>
                      </div>
                      <button
                        className="delete-button"
                        onClick={() => deleteProduct(product.id)}
                      >
                        Löschen
                      </button>
                    </li>
                  ))
                ) : (
                  <p>Keine Produkte in dieser Kategorie vorhanden.</p>
                )}
              </ul>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default DeleteProduct;
